import { render, staticRenderFns } from "./video-modal-activator.vue?vue&type=template&id=12d1c03a"
import script from "./video-modal-activator.vue?vue&type=script&lang=js"
export * from "./video-modal-activator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports